// Article metadata for the application
export interface Article {
  title: string
  slug: string
  description: string
}

// Export the article list for use throughout the application
export const articles: Article[] = [
  {
    title: 'The Ultimate Guide to Scheduling Messages in Microsoft Teams',
    slug: 'ultimate-guide-scheduling-messages-microsoft-teams',
    description: 'A comprehensive guide to scheduling messages in Microsoft Teams using DelayedSend. Learn how to plan, schedule, and manage your team communications efficiently.'
  },
  {
    title: 'How to Improve Work-Life Balance with Scheduled Teams Messages',
    slug: 'improve-work-life-balance-scheduled-teams-messages',
    description: 'Discover how scheduled messages in Microsoft Teams can help create healthier boundaries, reduce after-hours work, and improve your overall work-life balance.'
  },
  {
    title: '10 Business Use Cases for Scheduled Microsoft Teams Messages',
    slug: 'business-use-cases-scheduled-microsoft-teams-messages',
    description: 'Explore ten powerful business applications of scheduled messages in Microsoft Teams, from client communications to project management and team coordination.'
  },
  {
    title: 'DelayedSend vs. Native Teams Features: What You Need to Know',
    slug: 'delayedsend-vs-native-teams-features-comparison',
    description: 'A detailed comparison of DelayedSend and native Microsoft Teams scheduling features, highlighting key differences, advantages, and when to use each option.'
  },
  {
    title: 'How to Effectively Manage Cross-Timezone Teams Communication',
    slug: 'manage-cross-timezone-teams-communication',
    description: 'Learn strategies for coordinating communication across multiple time zones using DelayedSend for Microsoft Teams to enhance productivity and team cohesion.'
  },
  {
    title: 'Getting Started with Delayed Send for Microsoft Teams',
    slug: 'getting-started-delayed-send-microsoft-teams',
    description: 'A beginner\'s guide to using Delayed Send for Microsoft Teams. Learn how to schedule messages, manage delivery times, and optimize your team communications.'
  },
  {
    title: 'Boost Employee Onboarding with Scheduled Teams Messages',
    slug: 'boost-employee-onboarding-scheduled-teams-messages',
    description: 'Discover how to create structured onboarding sequences using scheduled messages in Microsoft Teams to improve the new employee experience and integration.'
  },
  {
    title: 'How to Never Miss Important Team Announcements with DelayedSend',
    slug: 'never-miss-important-team-announcements-delayedsend',
    description: 'Learn strategies for ensuring your important team announcements are seen and acted upon using DelayedSend for Microsoft Teams. Discover optimal timing, content structure, and follow-up techniques.'
  },
  {
    title: 'The Psychology of Timed Communication: Send Messages When They Matter Most',
    slug: 'psychology-timed-communication-send-messages-when-matter-most',
    description: 'Discover the science behind message timing and how to use DelayedSend for Microsoft Teams to deliver communications when they\'ll have the greatest impact and reception.'
  },
  {
    title: 'How to Schedule and Manage Microsoft Teams Messages with DelayedSend',
    slug: 'how-to-schedule-manage-microsoft-teams-messages-delayedsend',
    description: 'A comprehensive guide to scheduling, managing, and optimizing Microsoft Teams messages using DelayedSend. Learn everything from basic scheduling to advanced message management strategies.'
  },
  {
    title: 'Creating a More Thoughtful Communication Culture with DelayedSend',
    slug: 'creating-more-thoughtful-communication-culture-delayedsend',
    description: 'Learn how to build a more intentional, respectful, and effective communication culture using DelayedSend for Microsoft Teams. Discover strategies for reducing interruptions, improving message quality, and fostering healthier workplace communication.'
  },
  {
    title: 'Time-Saving Tips: Getting the Most from DelayedSend for Microsoft Teams',
    slug: 'time-saving-tips-getting-most-from-delayedsend-microsoft-teams',
    description: 'Discover advanced techniques, shortcuts, and strategies to maximize your productivity with DelayedSend for Microsoft Teams. Learn how to save time while creating more effective team communications.'
  }
];

// Function to get article metadata by slug
export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(article => article.slug === slug);
}